var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGolf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 4.209,
    cy: 4.224,
    r: 4.19
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.139 8.605a6.21 6.21 0 0 0 2.244 0v.5a3.912 3.912 0 0 1-2.244 0v-.5zm.102.817c.68.164 1.362.159 2.044.001-.697 1.374-.704 3.147-.653 5.327l-.332.009c-.403.009-.605.006-.604-.009l.007-.112c.057-.978.1-3.806-.461-5.214l-.001-.002z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    transform: "translate(3)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00BD2C",
    d: "M7.157 13.407c.09 0 .173.077.236.203.07-.326.167-.7.263-1.1.445-1.847.949-1.44 1.71-1.981-.16 1.322-1.36 2.477-1.4 2.664 1.524-2.14 2.386-1.835 3.26-2.16-.292 1.795-1.682 1.234-2.096 1.982-.098.175-.694.277-.78.443.288-.134.648-.278 1.804-.011-.48.11-.99.627-1.288.993-.445.55-1.24.72-1.476.518a.213.213 0 0 1-.054-.068c-.052.07-.114.11-.179.11-.069 0-.096-1.593 0-1.593z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00BD2C",
    d: "M7.284 13.407c-.09 0-.174.077-.236.203-.07-.326-.167-.7-.263-1.1-.445-1.847-.95-1.44-1.71-1.981.16 1.322 1.36 2.477 1.4 2.664-1.524-2.14-2.386-1.835-3.26-2.16.291 1.795 1.682 1.234 2.096 1.982.097.175.694.277.78.443-.288-.134-.648-.278-1.804-.011.48.11.99.627 1.287.993.446.55 1.24.72 1.477.518a.213.213 0 0 0 .054-.068c.052.07.113.11.179.11.069 0 .096-1.593 0-1.593z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolf);
export default __webpack_public_path__ + "static/media/golf.7b305d3f27eb54812eed9ecf63a0b142.svg";
export { ForwardRef as ReactComponent };